import { render, staticRenderFns } from "./SportsList.vue?vue&type=template&id=3e896c35&"
import script from "./SportsList.vue?vue&type=script&lang=ts&"
export * from "./SportsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports